import { ColumnDef } from "@tanstack/react-table";

import { AttendanceRequest } from "./schema";

import { DataTableColumnHeader } from "./data-table-column-header";
import { Badge } from "@/components/ui/badge/badge";
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "@/components/ui/hover-card/hover-card";
import { format } from "date-fns";

// import { DataTableRowActions } from "./data-table-row-actions";

export function getColumns(): ColumnDef<AttendanceRequest>[] {
  return [
    {
      accessorKey: "id",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Index" />
      ),
      cell: ({ row }) => {
        return (
          <div className="flex space-x-2">
            <span>{row.index + 1}</span>
          </div>
        );
      },
      enableSorting: false,
    },
    {
      accessorKey: "notes",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Notes" />
      ),
      cell: ({ row }) => {
        return (
          <HoverCard>
            <HoverCardTrigger className="hover:underline truncate hover:cursor-pointer">
              {row.getValue("notes")}
            </HoverCardTrigger>
            <HoverCardContent>
              <span className="max-w-[500px] truncate font-medium">
                {row.getValue("notes")}
              </span>
            </HoverCardContent>
          </HoverCard>
        );
      },
    },

    {
      accessorKey: "date",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Date" />
      ),
      cell: ({ row }) => {
        return (
          <HoverCard>
            <HoverCardTrigger>
              {format(new Date(row.getValue("date")), "PPP")}
            </HoverCardTrigger>
            <HoverCardContent>
              <span className="max-w-[500px] truncate font-medium">
                {row.getValue("phone")}
              </span>
            </HoverCardContent>
          </HoverCard>
        );
      },
    },

    {
      accessorKey: "status",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Status" />
      ),
      cell: ({ row }) => {
        return (
          <div className="flex space-x-2">
            <Badge>{row.getValue("status")}</Badge>
          </div>
        );
      },
    },

    // {
    //   id: "actions",
    //   cell: ({ row }) => <DataTableRowActions row={row} />,
    // },
  ];
}
